exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nul[data-v-47405fe8] {\n\tlist-style: none;\n}\nul > li > a[data-v-47405fe8] {\n\tcolor: #626368;\n\ttext-decoration: none;\n\tfont-weight: 600;\n}\nul > li > a[data-v-47405fe8]:hover {\n\tcolor: #353ea1;\n}\n", ""]);

// exports
